<template>
    <v-img ref="avatar" :src="userAvatar"></v-img>
</template>
<script>

export default {
    data() {
        return {}
    },   
    methods: {
        refreshAvatar() {
            this.$refs.avatar.src = this.$store.state.avatar
        }
    },
    computed: {
        userAvatar() {
            return this.$store.state.avatar
        }
    },
    mounted() {
        this.$root.$on('updateUserAvatar', (data) => {
            if (data=='updateUserAvatarHandler') this.refreshAvatar()
        })
    },
    created() {}
}
</script>